<div id="welcome" class="welcome-area">
    <div class="container">
        <div class="section-title">
            <h4>Cidhum</h4>
            <h2>Centro de Investigaciones en Desarrollo Humano</h2>
            <p>
                Nuestros Grupos de Investigación están formados por equipos multidisciplinarios de
                profesionales y expertos en abordar los temas de nuestras diversas líneas de investigación.
            </p>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-box">
                    <div class="icon">
                        <i class="fa-solid fa-users"></i>
                    </div>
                    <h3>Grupo de Investigación en Desarrollo Humano</h3>
                    <p>Cuenta con 29 años de existencia y experiencia. En la primera convocatoria, en 1996, fue
                        catalogado
                        por Minciencias como uno de los 13 grupos de investigación de excelencia en Colombia.
                        Actualmente está escalafonado
                        en la categoría A1. Ha recibido durante 35 años apoyo técnico y financiero de la
                        Fundación Bernard Van Leer de Holanda y también importantes instituciones como CKN del Reino
                        Unido,
                        UNESCO, UNICEF, Organización Mundial de la Salud. Ha recibido 11 premios nacionales e
                        internacionales.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-box">
                    <div class="icon">
                        <i class="fas fa-laptop"></i>
                    </div>
                    <h3>Grupo de Investigación en Psicología</h3>
                    <p>Formado desde el año 1996, que se encuentra escalafonado por Colciencias en A1.
                        Este grupo se visiona como un núcleo de generación de conocimiento en el área de
                        psicología vinculado a redes internacionales de investigación, produciendo artículos,
                        libros científicos, formando investigadores en psicología y educación, y desarrollando
                        una amplia socialización del conocimiento llegando con tecnologías apropiadas a
                        diversos sectores de la población que enfrentan desafíos en todas las dimensiones
                        del desarrollo del ser humano.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-box">
                    <div class="icon">
                        <i class="far fa-life-ring"></i>
                    </div>
                    <h3>Grupo de Investigación en Comunicación, Cultura y Cambio Social</h3>
                    <p>Se encuentra reconocido y catalogado por Colciencias en A1. El grupo articula y
                        reúne proyectos e investigaciones en el área de comunicación, y sustenta la actividad
                        de la Maestría y el Doctorado en Comunicación que ofrece la Universidad del Norte.
                        Cuenta con una vasta producción intelectual, tanto en términos de libros como de
                        artículos científicos en revistas de alto impacto indexadas en ISI y Scopus.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="shape2"><img src="assets/img/shape1.png" alt="image" loading="lazy"></div>
</div>
